import { CALL_API } from '../../../middleware/api';
import { apiEndpoints } from '../../../services/ApiEndpointsConstants';

import * as API from '../../../services/ApiEndpointsConstants';
import * as AdminConstants from './UserConstants';

// export function getAllUsersData() {
//   return {
//     [CALL_API]: {
//       endpoint: apiEndpoints().entity(API.GET_ALL_USERS),
//       types: [
//         AdminConstants.GET_ALL_USERS_DATA_REQUEST,
//         AdminConstants.GET_ALL_USERS_DATA_SUCCESS,
//         AdminConstants.GET_ALL_USERS_DATA_CLEAR,
//       ],
//     },
//   }
// }

export function getUserStatisticDataById(userId, startDate, endDate) {
  return {
    [CALL_API]: {
      // endpoint: apiEndpoints().entity(API.GET_USER_STATISTIC_BY_ID).replace('{id}', userId),
      endpoint: apiEndpoints().entity(
        `${API.GET_USER_STATISTIC_BY_ID}/${userId}?start=${startDate}&end=${endDate}`
      ),
      types: [
        AdminConstants.GET_USER_STATISTIC_DATA_BY_ID_REQUEST,
        AdminConstants.GET_USER_STATISTIC_DATA_BY_ID_SUCCESS,
        AdminConstants.GET_USER_STATISTIC_DATA_BY_ID_FAILED
      ]
    }
  };
}

export function getLoggedUserStatisticData(startDate, endDate) {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints().entity(
        `${API.GET_LOGGED_USER_STATISTIC}?start=${startDate}&end=${endDate}`
      ),
      // endpoint: apiEndpoints().entity(`${API.GET_USER_STATISTIC_BY_ID}/${userId}?start=${startDate}&end=${endDate}`),
      types: [
        AdminConstants.GET_LOGGED_USER_STATISTIC_DATA_REQUEST,
        AdminConstants.GET_LOGGED_USER_STATISTIC_DATA_SUCCESS,
        AdminConstants.GET_LOGGED_USER_STATISTIC_DATA_FAILED
      ]
    }
  };
}

export function getAllUsersStatisticData(startDate, endDate) {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints().entity(
        `${API.GET_ALL_USERs_STATISTIC}?start=${startDate}&end=${endDate}`
      ),
      // endpoint: apiEndpoints().entity(`${API.GET_USER_STATISTIC_BY_ID}/${userId}?start=${startDate}&end=${endDate}`),
      types: [
        AdminConstants.GET_ALL_USERS_STATISTIC_DATA_REQUEST,
        AdminConstants.GET_ALL_USERS_STATISTIC_DATA_SUCCESS,
        AdminConstants.GET_ALL_USERS_STATISTIC_DATA_FAILED
      ]
    }
  };
}

// export const changeRunQueryObject = (data, deleteIndex = null) => {
//   return {
//     type: AdminConstants.CHANGE_RUN_QUERY_OBJECT,
//     data: data,
//     deleteIndex: deleteIndex,
//   }
// }
